// 功能開放彈窗 - 社群連結
import Image from 'next/image';
import { OFFICIAL_URL } from '@/common/constant';

// 社群
const social = [
    {
        title: 'Facebook',
        link: OFFICIAL_URL.FACEBOOK,
    },
    {
        title: 'Instagram',
        link: OFFICIAL_URL.INSTAGRAM,
        background: 'bg-[#EC56DC]',
        hoverBackground: 'group-hover:bg-[#826094]',
    },
    {
        title: 'Threads',
        link: OFFICIAL_URL.THREADS,
    },
];

const ComingFollow = ({ t, onClose }) => {
    return (
        <div className="text-center text-white flex w-full h-full relative z-[1] flex-col center-center pt-[3vh]">
            <p className="text-h3">{t('ADULT_STEP_3')}</p>

            <pre className="text-bd1m mt-[2px] mb-[10px]">{t('ADULT_CONTENT_3')}</pre>

            <div className="flex gap-x-[30px] items-center">
                {social.map((v, i) => (
                    <a
                        key={'adult-modal-' + v.title + i}
                        target="_blank"
                        rel="noreferrer noopener"
                        href={v.link}
                        className="text-white text-btn1 flex-col center-center"
                    >
                        <Image
                            className="filter-white"
                            width={60}
                            height={60}
                            src={`/images/icon/icon_${v.title.toLowerCase()}.svg`}
                            alt="icon"
                        />
                        {v.title}
                    </a>
                ))}
            </div>

            <button
                onClick={onClose}
                className="text-btn1b bg-white rounded-[40px] text-plum trans py-[15px] mx-auto w-full max-w-[200px] mt-[20px]
                shadow-[0_0_10px_0_rgba(255,255,255,.39)] hover:text-[16px] h-[50px]"
            >
                {t('ADULT_BUTTON_3')}
            </button>
        </div>
    );
};

export default ComingFollow;
